// src/utils/analysis/JsonTextAnalysis.js

// Import the flattened performance data function
import { flattenPerformanceData } from './FlattenPerformanceData';

// Parse the bits from the flattened data
export const parseBits = () => {
  // Step 1: Load and flatten the performance data
  const bits = flattenPerformanceData(); // Load flattened bits directly
  // console.warn("??????????????????????????????????????????????????!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! WHEN IS THIS FNX CALLED?! : flattenedBits from JsonTextAnalysis: ", bits)
  // Step 2: Return the bits array as-is since it's already formatted
  return bits;
};

// Count the total number of punchlines across all jokes
export const countTotalNumOfPunchlines = (jokes = []) => { // jokes = ([{1},{2},{3},{4},{5},{6}]) jokes include .title, etc.
  // Step 1: Iterate over each joke and count the punchlines
  return jokes.reduce((count, joke) => {
    return count + (joke.punchline ? 1 : 0); // Count the main punchline if it exists
  }, 0); // Initialize count at 0
};


// Count the total number of taglines across all jokes
export const countTotalNumOfTaglines = (jokes = []) => { // jokes = ([{1},{2},{3},{4},{5},{6}]) jokes include .title, etc.

  return jokes.reduce((count, joke) => {
    if (joke.taglines) {
      joke.taglines.forEach(tagline => {
        // Check if tagline.punchline.text is an array and count its length, otherwise count it as 1
        const numTaglines = Array.isArray(tagline.punchline.text) 
                            ? tagline.punchline.text.length 
                            : 1;
        count += numTaglines;
      });
    }
    return count;
  }, 0); // Initialize count at 0
};



export const countTotalSetupLengthOfPerformance = (jokes = []) => {
  return jokes.reduce((totalSetupWords, joke) => {
    // Count words in the main setup only
    const setupText = Array.isArray(joke.setup) ? joke.setup.join(' ') : joke.setup;
    totalSetupWords += setupText.split(/\s+/).filter(Boolean).length; // Count words in the setup

    return totalSetupWords;
  }, 0); // Initialize totalSetupWords at 0
};


export const countTotalPunchlineLengthOfPerformance = (jokes = []) => {
  return jokes.reduce((totalPunchlineWords, joke) => {
    // Count words in the main punchline text only
    const punchlineText = joke.punchline.text || '';
    totalPunchlineWords += punchlineText.split(/\s+/).filter(Boolean).length; // Count words in the punchline

    return totalPunchlineWords;
  }, 0); // Initialize totalPunchlineWords at 0
};

export const countTotalTaglineLengthOfPerformance = (jokes = []) => {
  return jokes.reduce((totalTaglineWords, joke) => {
    totalTaglineWords += (joke.taglines || []).reduce((taglineWords, tagline) => {
      const taglinePunchlineText = Array.isArray(tagline.punchline.text) 
      ? tagline.punchline.text.join(' ') 
      : tagline.punchline.text;
taglineWords += taglinePunchlineText.split(/\s+/).filter(Boolean).length; // Count words in tagline punchline
      return taglineWords;
    }, 0);

    return totalTaglineWords;
  }, 0);
};


